import { render, staticRenderFns } from "./VacanciesListDetail.vue?vue&type=template&id=8af0a6c0&scoped=true&"
import script from "./VacanciesListDetail.vue?vue&type=script&lang=js&"
export * from "./VacanciesListDetail.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesListDetail.vue?vue&type=style&index=0&id=8af0a6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af0a6c0",
  null
  
)

/* custom blocks */
import block0 from "./VacanciesListDetail.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacanciesListDetail.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VTextField,VTextarea})
